<section class="line-item-modal-container">
    <div class="modal-header">
        <h5 class="modal-title pull-left">
            Attachments
        </h5>
        <a class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span class="fa fa-times-circle fa-2x" aria-hidden="true"></span>
        </a>
    </div>
    <div class="modal-body">
        <div class="modal-body__content">
            <div class="card mt-1">
                <div class="card-body p-4">
                        <!-- d-flex -->
                        <div class="file-upload">
                            <div class="row">
                                <div class="col-xl-6 col-lg-6 col-sm-12 col-md-12 pt-5 position-relative">
                                    <div class="upload-container">
                                        <div class="upload-icon mx-3">
                                            <span class="fa fa-cloud-upload fa-5x"></span>
                                        </div>
                                        <div class="upload-title mx-3">
                                            <p>
                                                "Drag and drop the file to upload"
                                            </p>
                                        </div>
                                        <input type="file" #inputFile id="choose" (change)="verifyFile($event)" />
                                    </div>
                                    <div class="text-center my-3">
                                        <a class="btn btn-outline-primary btn-lg" (click)="inputFile.click()">
                                            Choose File
                                        </a>
                                    </div>
                                    <!-- <div class="text-center my-3">
                                        <input class="form-control form-control-sm" type="text" id="upload_remarks" placeholder="Enter Remarks" [(ngModel)]="upload_remarks">
                                    </div> -->
                                    <div class="upload-instructions my-5 text-start">
                                        <h6>Upload Instructions: </h6>
                                        <ul>
                                            <li class='font-small'>
                                                1. During file upload, total size of the file must not exceed 20MB
                                            </li>
                                            <li class='font-small'>
                                                2. Only one file can be uploaded at a time
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="divider"></div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-sm-12 col-md-12 pt-5" *ngIf="prFiles?.length">
                                    <div class="px-4 py-1">
                                        <div class="text-start">
                                            <h6 class="fs-6">File Status</h6>
                                            <p className="text-muted my-3">
                                                File to be uploaded ({{prFiles?.length}} file
                                                ).
                                            </p>
                                        </div>
                                        <div class="my-4 upload-view" *ngFor="let file of prFiles">
                                            <div>
                                                <p class='mb-1'>
                                                    {{file?.file?.name}}
                                                </p>
                                                <p class="mb-0 font-small">
                                                    <!-- {{file?.formatSize}} -->
                                                </p>
                                            </div>
                                            <div class='align-self-center'>
                                                <a class='pointer' (click)="clearFile()">
                                                    <span class="fa fa-trash fa-2x"></span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    <div class="modal-footer">
        <a class="btn btn-outline-primary mx-2" (click)="onModalClose()">Cancel</a>
        <a *ngIf="prFiles?.length" class="btn btn-outline-primary mx-2" (click)="UploadAttachment()">Upload</a>
    </div>
</section>